<template>
    <div class="coffee-overview">
        <div class="overview-image-text-container coffee-overview-image-text-container">
            <figure v-show="sizeCategory ==='large_size'&& bagImgLoaded"
                    class="overview-image coffee-overview-image overview-large-bag slideRight"
                    :data-image-extrasmall="image_extra_small_lb"
                    :data-image-small="image_small_lb"
                    :data-image-medium="image_medium_lb"
                    :data-image-mediumlarge="image_large_lb"
                    :data-image-large="image_large_lb">
            </figure>
            <figure v-show="(sizeCategory === 'small_size'||sizeCategory === 'sample_size'||sizeCategory === 'case_size'||sizeCategory === 'medium_size') && bagImgLoaded" class="overview-image coffee-overview-image slideRight"
                    :data-image-extrasmall="image_extra_small_sb"
                    :data-image-small="image_small_sb"
                    :data-image-medium="image_medium_sb"
                    :data-image-mediumlarge="image_large_sb"
                    :data-image-large="image_large_sb">
            </figure>
            <span class="overview-text coffee-overview-text">
                <section>

                    <!-- Roaster -->
                    <h4 class="coffee-overview-roaster">
                        <a data-track-click="Click on seller"
                           data-track-description="Coffee detail page text near the top"
                           :data-track-id="coffee.seller.id"
                           :data-track-name="coffee.seller.name"
                           :href="'/roasters/' + coffee.seller.slug">{{ coffee.seller.name }}
                        </a>
                    </h4>

                    <!-- Coffee Name -->
                <h1 class="coffee-overview-heading blue" itemprop="name">
                    {{coffee.name}}
                </h1>

                    <!-- Coffee Tasting Notes -->
                <body>
                    <span v-for="(note, index) in coffee.tasting_notes" :key="index">
                        {{ note.toLowerCase() }} <span v-if="index < coffee.tasting_notes.length - 1"> | </span>
                    </span>
                </body>

                <br>
                <body>Choose your bag size:</body>
                <br>

                    <!-- Sizes -->
                <table v-bind:class="{ 'rd19-single-size-container': available_single_size,
                'rd19-sizes-container' : !available_single_size }"><tr>
                <span v-if="productCustomSizes" v-for="name in getSizeName">
                    <td class="rd19-size-box" v-bind:class="{'active': customSizeSelected === name}"
                    @click="customSizeSelected = name"><body class="transparent-background">{{ getProductDisplaySize(coffee, name) }}</body><br>
                    <h1 class="blue active">{{ formatPrice(customSizePrice(name)) }}</h1>
                    <br><br></td>
                </span>
                </tr></table>

                <slot></slot>

                <!-- Coffee Grinds -->
                <div v-if="productCustomSizes">
                    <div v-for="(name, index) in getSizeName">
                        <div v-if=" customSizeSelected === name">
                           <div v-if="customGrindType(name).length >= 1"  class="flexbox-row-container grinds-container layered-active-list">
                                <div v-for="(grind, index) in all_grinds" :key="index"
                                class="layered-button-container grind-button-container"
                                v-bind:class="{'active': customSelectedGrind === grind ,  'disabled': !customGrind.includes(grind)}" @click="customSelectedGrind = grind">
                                <img class="layered-button-image"
                                v-bind:src="'/coffee-images/' + grind + '-button.png?20190604'">
                                <img class="layered-button-hover-image"
                                v-bind:src="'/coffee-images/' + grind + '-button-blk.png?20190604'">
                                <img class="layered-button-active-image"
                                v-bind:src="'/coffee-images/' + grind + '-button-blk.png?20190604'">
                            </div>
                           </div>
                        </div>
                    </div>
                </div>

                <template v-if="show_brewlist_button">
                    <div @click="buyNow()" class="rd19-coffee-button buy-now-btn">
                        Buy Now
                    </div>

                    <div v-if="productCustomSizes" class="rd19-coffee-button add-to-brewlist"
                        :id="'add-to-brewlist' + coffee.id"
                        :data-product-id="coffee.id"
                        data-text-default="Add to Brew Queue"
                        data-text-added="In Brew Queue"
                        data-track-click="Add to Brewlist"
                        data-track-description="From top of coffee detail page"
                        :data-track-id="coffee.id"
                        :data-track-name="coffee.name"
                        :data-product-grind="customSelectedGrind"
                        :data-product-size="customSizeSelected"
                        @click="confirmGrind(customSelectedGrind)">
                    Add to Brew Queue
                    </div>

                    <div @click="buyNow(true)" class="rd19-coffee-button send-to-friend-btn">
                        Send to Friend
                    </div>

                    <buy-now-form-shell
                        v-if="show_brewlist_button"
                        :order="buyNowOrder"
                        :buy-now-discounts="buyNowProps.buyNowDiscounts"
                        :custom-bag-discounts="buyNowProps.customBagDiscounts"
                        :is-user-signed-in="buyNowProps.isUserSignedIn"
                        :stripe-publishable-key="buyNowProps.stripePublishableKey"
                        :username="buyNowProps.username"
                        :email="buyNowProps.email"
                        :shipping="buyNowProps.shipping"
                        :credit-card-last-digits="buyNowProps.billing && buyNowProps.billing.creditCardLastDigits"
                        :applicable-credit-amount-cents="buyNowProps.applicableCreditAmountCents"
                        :current-url="buyNowProps.currentUrl"
                        :tax-rate="buyNowProps.taxRate"
                        :key="'details-buy-now' + buyNowComponentKey"
                        v-on:closed="onBuyNowFormClosed"
                        ref="buyNowForm"
                    />

                    <grind-confirmation-modal
                            v-if="productCustomSizes"
                            :grind="customSelectedGrind"
                            :brew-grind="brewlistDetails"
                            v-on:confirmed="addBtnElem.trigger('add')"
                            ref="grindConfirmationModal"
                    />
                </template>
            </section>
            </span>
        </div>
    </div>
</template>

<script>
    import GrindConfirmationModal from './grind-confirmation-modal';
    import BuyNowFormShell from "./buy-now/buy-now-form-shell";
    import CommonMixin from '../../mixins/common-mixin';
    import BuyNowMixin from "../../mixins/buy-now-mixin";
    import CoffeeMixin from "../../mixins/coffee-mixin";

    export default {
        components: {
            BuyNowFormShell,
            GrindConfirmationModal
        },
        mixins: [
            CommonMixin,
            BuyNowMixin,
            CoffeeMixin
        ],
        props: {
            coffee: {},
            image_extra_small_sb: String,
            image_small_sb: String,
            image_medium_sb: String,
            image_large_sb: String,
            image_extra_small_lb: String,
            image_small_lb: String,
            image_medium_lb: String,
            image_large_lb: String,
            available_5lb: Boolean,
            available_12oz: Boolean,
            available_single_size: Boolean,
            url_link: String,
            certifications_html: String,
            show_brewlist_button: Boolean,
            price_discounted_cents: Number,
            price_5lb_discounted_cents: Number,
            grindDefault: String,
            sizeDefault: String,
            productCustomSizes: Boolean,
            buyNowProps: Object,
            brewlistDetails: Object
        },
        data: function () {
            return {
                all_grinds: ['whole_bean', 'course', 'medium', 'fine'],
                bagImgLoaded: false,
                grind: this.grindDefault,
                size: this.sizeDefault,
                buyNowOrder: undefined,
                buyNowComponentKey: 0,
                customSizeSelected: undefined,
                customGrindName: undefined,
                customSelectedGrind: undefined,
                brewqueueSizes: [],
                sizeCategory: undefined
            }
        },
        methods: {
            selectGrind(grind) {
                this.grind = grind
            },
            grindActive(grind) {
                return {
                    active: grind === this.grind
                }
            },
            grindAvailable(grind) {
                if (this.size === '12oz' || this.size === '10oz') {
                    return this.coffee.grinds.includes(grind)
                }

                return this.coffee.grinds_5lb.includes(grind)
            },
            grindUnavailable(grind) {
                return {
                    disabled: !this.grindAvailable(grind)
                }
            },
            buyNow(isGift = false) {
                this.buyNowOrder = {
                    coffeeId: this.coffee.id,
                    coffeeName: this.coffee.name,
                    size: this.customSizeSelected,
                    displaySize: this.getProductDisplaySize(this.coffee, this.customSizeSelected),
                    grind: this.customSelectedGrind,
                    unitPrice: this.customSizePrice(this.customSizeSelected),
                    bagImageUrl: this.size === '5lb' ? this.image_small_lb : this.image_small_sb,
                    isSampler: this.coffee.is_sampler,
                    isGift: isGift
                };
                setTimeout(() => this.$refs.buyNowForm.open(), 250);
                // HACK: wait for binding the order
            },
            onBuyNowFormClosed() {
                this.buyNowComponentKey += 1;
            },
            confirmGrind(grind) {
                if (this.addBtnElem.hasClass('active')) {
                    return;
                }

                if (grind != this.brewlistDetails.grind) {
                    this.$refs.grindConfirmationModal.show(this.brewlistDetails.grind);
                } else {
                    this.addBtnElem.trigger('add');
                }
            },
            customGrindType(name){
                if (this.buyNowProps.measureUnit == 'metric_uom') {
                    var grindName = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.metric_uom) ? m.grinds : null; }).filter(f => {return (f !== null); });
                } else {
                    var grindName = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.imperial_uom) ? m.grinds : null; }).filter(f => {return (f !== null); });
                }
                this.customGrindName = grindName[0];
                if (this.brewlistDetails != undefined && this.customGrindName.includes(this.brewlistDetails.grind) && this.customSelectedGrind === undefined ){
                    this.customSelectedGrind = this.brewlistDetails.grind;
                }else{
                    this.customSelectedGrind = this.customSelectedGrind != undefined && this.customGrindName.includes(this.customSelectedGrind) ? this.customSelectedGrind : this.customGrindName[0];
                }
                this.sizeCategory = this.coffee.product_custom_sizes.filter(r=> r.custom_size.imperial_uom === this.customSizeSelected)[0].custom_size.size_category
                return grindName[0];
            },
            customSizePrice(name) {
                if (this.buyNowProps.measureUnit == 'metric_uom') {
                    var product_price = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.metric_uom) ? m.price_cents : null; }).filter(r => {return (r != null)} );
                    var platformfee = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.metric_uom) ? m.custom_size.platform_fee.cents: null; }).filter(r => {return (r != null)} );
                } else {
                    var product_price = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.imperial_uom) ? m.price_cents : null; }).filter(r => {return (r != null)} );
                    var platformfee = this.coffee.product_custom_sizes.map((m) => {return (name == m.custom_size.imperial_uom) ? m.custom_size.platform_fee.cents: null; }).filter(r => {return (r != null)} );
                }
                let total = product_price[0] + platformfee[0];       
                return total;
            },
        },
        watch: {
            size: function () {
                // TODO: This won't work if 'whole bean' is not available
                if (!this.grindAvailable(this.grind)) {
                    this.grind = 'whole_bean';
                }
            }
        },
        computed: {
            addBtnElem: function() {
                return $("#add-to-brewlist"+this.coffee.id);
            },
            getSizeName: function() {
                var name = [];
                if (this.buyNowProps.measureUnit === 'metric_uom'){
                    var g = this.coffee.product_custom_sizes.map(r => {
                        if (!r.custom_size.metric_uom.includes('kg')) {
                            return r.custom_size.metric_uom;
                        }}).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    var kg = this.coffee.product_custom_sizes.map(r => {
                        if (r.custom_size.metric_uom.includes('kg')) {
                            return r.custom_size.metric_uom;
                        }}).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    name = g.concat(kg).filter(function( element ) {
                        return element !== undefined;
                    });
                } else {
                    var oz = this.coffee.product_custom_sizes.map(r => {
                      if (r.custom_size.imperial_uom.includes('oz')) {
                        return r.custom_size.imperial_uom;
                      }}).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    var lb = this.coffee.product_custom_sizes.map(r => {
                      if (r.custom_size.imperial_uom.includes('lb')) {
                        return r.custom_size.imperial_uom;
                      }}).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                    name = oz.concat(lb).filter(function( element ) {
                        return element !== undefined;
                    });
                }
                return name;
            },
            customGrind: function(){
              return this.customGrindName;
            }
        },
        mounted() {
            if(this.buyNowProps.measureUnit == 'imperial_uom'){
                this.brewqueueSizes = this.brewlistDetails.sizes.map(r => r.split("/")[0]).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
            }else if(this.buyNowProps.measureUnit == 'metric_uom'){
                this.brewqueueSizes = this.brewlistDetails.sizes.map(r => r.split("/")[0]).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
            }
            
            if (this.brewqueueSizes.length > 0){
                this.brewqueueSizes = this.brewqueueSizes.map(r => {return this.getSizeName.includes(r) ? r : 0 });
                this.brewqueueSizes = this.brewqueueSizes.filter(r=> r != 0);
            }

            if (this.brewqueueSizes.length > 0){
                this.customSizeSelected = this.brewqueueSizes[0];
            }else{
                this.customSizeSelected = (this.getSizeName !== undefined && this.getSizeName.length > 0) ? this.getSizeName[0] : '';
            }
            

            $("#add-to-brewlist"+this.coffee.id).brewlistAdd();
            $(".overview-image").responsiveImages({
                sizes: [{
                    name: 'small',
                    width: 516,
                    condition: 'resolution < 1.25'
                },{
                    name: 'medium',
                    width: 624,
                    condition: '(resolution > 1.25) && (width <= 360)'
                },{
                    name: 'large',
                    width: 1032,
                    condition: 'resolution > 1.25'
                }]
            });

            // Hack: Wait until coffee bag images are loaded.
            let localName = window.localStorage.getItem('sizeName');
            if ((this.buyNowProps.measureUnit != null && this.buyNowProps.measureUnit == 'imperial_uom') || (this.buyNowProps.measureUnit === null) ){
                this.customSizeSelected = localName != undefined && this.coffee.product_custom_sizes.filter(r=> r.custom_size.imperial_uom === localName)[0] != undefined ? localName : this.customSizeSelected
                this.sizeCategory =  this.coffee.product_custom_sizes.filter(r=> r.custom_size.imperial_uom === this.customSizeSelected)[0].custom_size.size_category
            }else if(this.buyNowProps.measureUnit != null && this.buyNowProps.measureUnit == 'metric_uom'){
                this.customSizeSelected = localName != undefined && this.coffee.product_custom_sizes.filter(r=> r.custom_size.metric_uom === localName)[0] != undefined ? localName : this.customSizeSelected
                this.sizeCategory =  this.coffee.product_custom_sizes.filter(r=> r.custom_size.metric_uom === this.customSizeSelected)[0].custom_size.size_category 
            }else{
                this.sizeCategory =  this.coffee.product_custom_sizes.filter(r=> r.custom_size.imperial_uom === this.customSizeSelected)[0].custom_size.size_category
            }
            window.localStorage.removeItem('sizeName');
            
            this.bagImgLoaded = true;
            

            const incompleteOrder = this.getIncompleteOrder();
            if (incompleteOrder && this.buyNowProps.isUserSignedIn) {
                this.buyNowOrder = incompleteOrder;
                setTimeout(() => this.$refs.buyNowForm.open(true), 3000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/variables_home";
    @import "../../styles/common_home";

    .buy-now-btn {
        cursor: pointer;
        background-color: $color-primary;

        &:hover {
            background-color: lighten($color-primary, 5%);
        }
        &:active {
            background-color: darken($color-primary, 5%);
        }
    }
    .send-to-friend-btn {
        cursor: pointer;
        background-color: $gold;

        &:hover {
            background-color: lighten($gold, 5%);
        }
        &:active {
            background-color: darken($gold, 5%);
        }
    }
    .add-to-brewlist{
        cursor: pointer;
    }


</style>
